export const DirectoryListingTypeDecorator = {
  url() {
    return `signup-hubspot/directory-listing`;
  },

  query() {
    return {};
  }

};